import { User } from '@groma-dev/scaffold';
import { AppConfig } from '../AppConfig';

export interface SignInStateInterface {
  isSubmitting: boolean;
}

export interface UserStateInterface {
  fetchingUser: boolean;
  user?: User;
}

export interface ResetPasswordStateInterface {
  isSubmitting: boolean;
}

export interface AcceptInvitationStateInterface {
  isSubmitting: boolean;
}

export const ScaffoldClientHeaders = {
  'Content-Type': `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
  Accept: `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
};
